<script setup>
import { ref } from 'vue'

const props = defineProps(['modelValue', 'filter', 'type', 'required', 'placeholder', 'disabled', 'max', 'label', 'icon', 'error', 'autocomplete', 'spellcheck', 'autocapitalize'])
const emit = defineEmits(['update:modelValue'])

const input = ref(null)
const ov = ref(null)
const oss = ref(null)
const ose = ref(null)
const handlers = ref({
	input: handleInput,
	keyup: handleInput,
	keydown: handleInput,
	select: handleInput,
	contextmenu: handleInput,
	drop: handleInput,
})

function handleInput(event) {
	if (props.filter == 'username') {
		if (/^[a-zA-Z0-9_ ]*$/i.test(input.value.value)) {
			ov.value = input.value.value.replace(/-+/g, '').replace(/\s+/g, '_').replace(/\_\_+/g, '_').replace(/^_+/, '')
			oss.value = input.value.selectionStart
			ose.value = input.value.selectionEnd
			input.value.value = ov.value
			emit('update:modelValue', ov.value)
		} else if (ov.value) {
			input.value.value = ov.value
			emit('update:modelValue', ov.value)
			input.value.setSelectionRange(oss.value, ose.value)
		} else {
			input.value.value = ''
			emit('update:modelValue', '')
		}
	} else if (props.filter == 'phone') {
		if (/^[0-9+()-]*$/i.test(input.value.value)) {
			ov.value = input.value.value.replace(/\s+/g, '-').replace(/\-\-+/g, '-').replace(/^-+/, '')
			oss.value = input.value.selectionStart
			ose.value = input.value.selectionEnd
			input.value.value = ov.value
			emit('update:modelValue', ov.value)
		} else if (ov.value) {
			input.value.value = ov.value
			emit('update:modelValue', ov.value)
			input.setSelectionRange(oss.value, ose.value)
		} else {
			input.value.value = ''
			emit('update:modelValue', '')
		}
	} else {
		emit('update:modelValue', event.target.value)
	}
}
</script>

<template>
	<div class="flex w-full flex-col gap-2 normal-case">
		<label class="font-semibold text-sm text-primary" v-if="label">
			{{ label }}
		</label>
		<div class="relative w-full">
			<i :class="'absolute left-6 top-1/2 text-sm -translate-y-1/2 ' + icon"></i>
			<input :class="{ 'icon-padding': icon }" :type="type || 'text'" :placeholder="placeholder" :maxlength="max" :required="required" v-on="handlers" :value="modelValue" :autocomplete="autocomplete" :disabled="disabled" :spellcheck="spellcheck" :autocapitalize="autocapitalize" ref="input" />
		</div>
		<p class="text-xs text-redBase" v-if="error">{{ error }}</p>
	</div>
</template>

<style scoped>
input {
	@apply w-full rounded-full border border-border px-4 py-3 font-medium text-sm normal-case placeholder:normal-case placeholder:text-primaryLightest focus:outline-none;
}

.icon-padding {
	@apply pl-12;
}
</style>
